import React, { FC } from "react";

import { DashboardEditorProps } from "components/ComponentType";
import SparkLineEditor from "../sparkline/SparkLineEditor";
import { SparkLineProps } from "../sparkline/SparkLineTypes";

const SparkLineAdvancedEditor: FC<DashboardEditorProps<SparkLineProps>> = ({
  config,
  onConfigChange,
}) => {
  return <SparkLineEditor config={config} onConfigChange={onConfigChange} advanced />;
};

export default SparkLineAdvancedEditor;
